import { z } from "zod";

/**
 * Onchain Swap Token API Response Types
 *
 * These schemas define the API contract for token lookup responses.
 * Used by both frontend and backend for type safety.
 */

// Token info from market data / token lookup
export const swapTokenInfoSchema = z.object({
  address: z.string(),
  symbol: z.string().optional(),
  name: z.string().optional(),
  decimals: z.number().int(),
  tokenSymbol: z.string().optional(),
  tokenName: z.string().optional(),
  market_cap: z.number().optional(),
  volume_24h: z.number().optional(),
  latest_price: z.number().optional(),
  logo: z.string().nullable().optional(),
});

// Types
export type SwapTokenInfo = z.infer<typeof swapTokenInfoSchema>;

export const SwapTokenByAddressResponseSchema = z.union([swapTokenInfoSchema, z.null()]);
export type SwapTokenByAddressResponse = z.infer<typeof SwapTokenByAddressResponseSchema>;
